function getCookie(name: string) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

function isRemoteLoading() {
  const appCookie = getCookie('app');

  return window.self !== window.top && appCookie === 'instore';
}

export { isRemoteLoading };
export default isRemoteLoading;
